export default class ReactHookFormUtil {
    static getNestedFormValues(
        formValues: { [x: string]: unknown; },
        formPrefix: string
    ) {
        let target = formValues;
        let formArray = formPrefix.split('.');
        for (let sect of formArray) {
            let index = sect.indexOf('[');
            if (index > -1) {
                let parent = sect.slice(0, index);
                let i = sect.slice(index + 1, sect.length - 1);
                target = target[parent] as { [x: string]: unknown };
                if (!!target) {
                    target = target[i] as { [x: string]: unknown };
                } else {
                    return undefined;
                }
            } else {
                target = target[sect] as { [x: string]: unknown };
            }
        }
        return target;
    }
}



// WEBPACK FOOTER //
// ./src/util/ReactHookFormUtil.ts